import { z } from "zod";
/**
 * Audience criteria language (doc 03 §6.2; R-AUD). Saved filters over contacts —
 * ONE source of truth for the Contacts chip bar and the Broadcast composer (R-AUD-1).
 * `optin=true` is ALWAYS implicit and cannot be expressed away (R-AUD-2). Keys AND
 * together; array values OR within a key.
 */
export const audienceCriteria = z.object({
    segment: z.array(z.enum(["new", "repeat", "vip"])).optional(),
    platform: z.array(z.enum(["shopify", "woocommerce"])).optional(),
    region: z.array(z.string()).optional(),
    optin: z.array(z.literal(true)).optional(), // round-trips the saved chip; redundant with the implicit AND
    q: z.string().optional(),
});
/** Pure membership test — mirrors the server SQL compiler (used for client preview + tests). */
export function matchesAudience(c, crit) {
    if (!c.optin)
        return false; // implicit, inexpressible-away (R-AUD-2)
    if (crit.segment?.length && !crit.segment.includes(c.segment))
        return false;
    if (crit.platform?.length &&
        !(c.sourcePlatform && crit.platform.includes(c.sourcePlatform)))
        return false;
    if (crit.region?.length && !(c.region && crit.region.includes(c.region)))
        return false;
    if (crit.q?.trim()) {
        const hay = `${c.name ?? ""} ${c.phone}`.toLowerCase();
        if (!hay.includes(crit.q.trim().toLowerCase()))
            return false;
    }
    return true;
}
//# sourceMappingURL=audience.js.map